/* eslint-disable react/display-name */
import { useQuery } from '@apollo/client';
import { GetGoalsQuery, GetGoalsQueryVariables } from 'lib/generated/graphql';
import { GET_GOALS } from 'lib/queries';
import { forwardRef, useImperativeHandle, useState } from 'react';
import MultiSelectGrid from 'src/shared-components/MultiSelectGrid';

interface FormGoalsProps {
  onFormSubmitted: (values: any) => void;
  initialValues: any;
}

const FormGoals = forwardRef(({ onFormSubmitted, initialValues }: FormGoalsProps, ref) => {
  const [selectedOptions, setSelectedOptions] = useState<any>(initialValues);
  const { data } = useQuery<GetGoalsQuery, GetGoalsQueryVariables>(GET_GOALS);

  useImperativeHandle(ref, () => ({
    submitForm() {
      // Do the mutation here or in the parent
      onFormSubmitted(selectedOptions.map((id: number) => ({ id })));
    },
  }));

  if (!data) return null;

  return (
    <div data-testid="create-project-step1">
      <MultiSelectGrid
        options={data.findGoals
          .filter(item => item.shown)
          .sort((a, b) => a.value.localeCompare(b.value))
          .map(item => ({ value: item.id, label: item.value }))}
        onChange={setSelectedOptions}
        initialValues={initialValues}
      />
    </div>
  );
});

export default FormGoals;
